import * as React from 'react';

import { SlickSlider, TSlickSettings } from '../SlickSlider';
import * as s from './ScrollableSlider.css';

export interface IScrollableSliderProps {
  slides: React.ReactNode[];
  onSlideMouseDown(e: React.MouseEvent<HTMLDivElement>): void;
  onSlideClickCapture(e: React.MouseEvent<HTMLDivElement>): void;
  visibleSlides: number;
}

export const ScrollableSlider: React.FC<IScrollableSliderProps> = ({
  slides,
  onSlideMouseDown,
  onSlideClickCapture,
  visibleSlides,
}) => {
  const settings = React.useMemo<TSlickSettings>(
    () => ({
      arrows: false,
      dots: false,
      infinite: false,
      slidesToShow: visibleSlides,
      slidesToScroll: 1,
      swipeToSlide: true,
      speed: 300,
    }),
    [visibleSlides],
  );

  return (
    <div className={s['container']}>
      <SlickSlider settings={settings} className={s['carousel']}>
        {slides.map((slide, index) => (
          <div key={index}>
            <div className={s['slide']} onMouseDown={onSlideMouseDown} onClickCapture={onSlideClickCapture}>
              {slide}
            </div>
          </div>
        ))}
      </SlickSlider>
    </div>
  );
};
